import { __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
import styles from './productAuthTag.module.scss';
import { useGetProductAuth, useShouldProductAuthTagDisplay } from '@web-common/hooks/useGetProductAuth';
import { getIn18Text } from 'api';
const ProductAuthTag = (_a) => {
    var { tagName, type = 'flow', tipText = getIn18Text('XIANSHITIYAN'), children, flowTipStyle, limitProductId } = _a, attr = __rest(_a, ["tagName", "type", "tipText", "children", "flowTipStyle", "limitProductId"]);
    const { className } = attr, rest = __rest(attr, ["className"]);
    const tagShow = useShouldProductAuthTagDisplay(tagName);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    if (limitProductId !== undefined && limitProductId !== productVersionId) {
        return React.createElement("span", Object.assign({}, attr), children);
    }
    if (tagShow) {
        if (type === 'bar') {
            return (React.createElement("div", Object.assign({ className: classNames(styles.tagWrapperBar, className) }, attr, { style: flowTipStyle }),
                children,
                tipText));
        }
        if (type === 'flow') {
            return (React.createElement("span", Object.assign({ className: classNames(styles.tagWrapperFlow, className) }, rest),
                children,
                React.createElement("span", { className: classNames(styles.tagEntity), style: flowTipStyle }, tipText)));
        }
    }
    return React.createElement("span", Object.assign({}, attr), children);
};
export function withProductAuthTag(WrappedComponent) {
    const ComponentWithProductAuthTag = (props) => {
        const { authTagProps } = props, rest = __rest(props, ["authTagProps"]);
        return (React.createElement(ProductAuthTag, Object.assign({}, authTagProps),
            React.createElement(WrappedComponent, Object.assign({}, rest))));
    };
    return ComponentWithProductAuthTag;
}
export default ProductAuthTag;
